var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWasherBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Box",
    xmlns: "http://www.w3.org/2000/svg",
    width: 257,
    height: 218,
    viewBox: "0 0 257 218",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9811",
    "data-name": "Group 9811"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3858",
    "data-name": "Path 3858",
    d: "M251.28,217.27H5.73a5,5,0,0,1-5-5V5.73a5,5,0,0,1,5-5H251.28a5,5,0,0,1,5,5V212.27A5,5,0,0,1,251.28,217.27Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3859",
    "data-name": "Path 3859",
    d: "M251.28,218H5.73A5.727,5.727,0,0,1,0,212.28V5.72A5.727,5.727,0,0,1,5.73,0H251.27A5.727,5.727,0,0,1,257,5.72V212.29A5.71,5.71,0,0,1,251.28,218ZM5.73,1.46A4.266,4.266,0,0,0,1.46,5.72V212.29a4.272,4.272,0,0,0,4.27,4.26H251.27a4.266,4.266,0,0,0,4.27-4.26V5.72a4.272,4.272,0,0,0-4.27-4.26H5.73Z",
    fill: "#f1f1f2"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_9812",
    "data-name": "Group 9812",
    transform: "translate(189.667 42.23)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3860",
    "data-name": "Path 3860",
    d: "M255.643,170.65H195.93c-3.46,0-6.27-2.53-6.27-5.63V47.86c0-3.11,2.81-5.63,6.27-5.63h59.712v1.29H195.93c-2.74,0-4.96,1.95-4.96,4.34V165.02c0,2.39,2.23,4.34,4.96,4.34h59.712v1.29Z",
    transform: "translate(-189.66 -42.23)",
    fill: "#bbbdbf"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWasherBox);
export default __webpack_public_path__ + "static/media/washer_box.ce4cd756d933a42bf0427d9d705e9ca5.svg";
export { ForwardRef as ReactComponent };